import * as React from 'react';
import { WalletContext, WalletContextProps } from '../WalletContext';

export const useWalletContext = (): WalletContextProps => {
    const wallet = React.useContext(WalletContext);
    if (!wallet) {
        throw new Error('Service is not registered yet');
    }

    return wallet;
};
